export default "__VITE_ASSET__DFY1eNFe__"